export default __webpack_public_path__ + "static/media/ColusaAerial.a09ec31a.png";